import React, { useEffect, useState } from 'react'
import Button from 'antd/lib/button'
import Input from 'antd/lib/input'
import Form from 'antd/lib/form'
import message from 'antd/lib/message'
import { Auth } from 'aws-amplify'
import { useSelector } from 'react-redux'
import { setErrorMessage, setShowResetPassword, setShowLogin } from '../../redux/auth/actions'
import Footer from './Footer'

const { Item } = Form

const styles = {
    linkRight: {
        color: '#1BAAF1',
        cursor: 'pointer',
        float: 'right',
    },
    submitButton: {
        width: '100%',
    },
    submitContainer: {
        textAlign: 'center',
    },
    error: {
        color: 'red',
        textAlign: 'center',
        fontSize: 14,
    },
}

const ResetPassword = ({ onStateChange, email }) => {
    const [_email, setEmail] = useState(email)
    const [password, setPassword] = useState('')
    const [resetSent, setResetSent] = useState(false)
    const [code, setCode] = useState(null)

    const errorMessage = useSelector((state) => state.auth.errorMessage)
    const passwordResetToken = useSelector((state) => state.auth.passwordResetToken)

    useEffect(() => {
        if (passwordResetToken) {
            setCode(passwordResetToken)
            setResetSent(true)
        }
    }, [passwordResetToken])

    const reset = () => {
        resetSent ? sendCode() : getCode()
    }

    const getCode = () => {
        setErrorMessage('')
        Auth.forgotPassword(_email.toLowerCase())
            .then((data) => {
                setResetSent(true)
                message.success('Verification Code Sent')
            })
            .catch((err) => setErrorMessage(err.message))
    }

    const sendCode = () => {
        Auth.forgotPasswordSubmit(_email.toLowerCase(), code, password)
            .then((data) => {
                setShowResetPassword(false)
                message.success('Your password has been reset. Please sign in')
            })
            .catch((err) => setErrorMessage(err.message))
    }

    return (
        <>
            <div style={styles.error}>{errorMessage}</div>
            <Form>
                {!resetSent && (
                    <Item label="E-mail">
                        <Input
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            value={_email}
                        />
                    </Item>
                )}
                {resetSent && (
                    <Item label="Verification Code">
                        <Input onChange={(e) => setCode(e.target.value)} type="text" value={code} />
                    </Item>
                )}
                {resetSent && (
                    <Item label="New Password">
                        <Input
                            onChange={(e) => setPassword(e.target.value)}
                            type="password"
                            value={password}
                        />
                    </Item>
                )}
                <Item style={styles.submitContainer}>
                    <Button
                        htmlType="submit"
                        onClick={reset}
                        size="large"
                        style={styles.submitButton}
                        type="primary"
                    >
                        {resetSent ? 'Submit' : 'Send Verification Code'}
                    </Button>
                </Item>
            </Form>
            {resetSent && (
                <span onClick={getCode} style={styles.linkRight}>
                    Resend Verification Code
                </span>
            )}
            <Footer onStateChange={onStateChange} />
        </>
    )
}

export default ResetPassword
